import React from 'react';

// Same reasoning as CropLoadErrorBoundary: React.lazy/Suspense only
// covers the *pending* state of a dynamic import; an actual load failure
// (e.g. a dropped network request for the chunk) surfaces as a thrown
// error during render, which needs a real error boundary. Unlike the
// crop modal, a lazy-loaded route has no parent prop to reset on
// failure, so retrying here just remounts its own children via a key
// bump instead of relying on a callback.
class LazyLoadErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, attempt: 0 };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('Failed to load a lazy-loaded chunk.', error, info);
  }

  handleRetry = () => {
    this.setState((state) => ({ hasError: false, attempt: state.attempt + 1 }));
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '60px 20px', textAlign: 'center' }}>
          <p>{this.props.message || 'Something failed to load.'}</p>
          <button className="btn btn-secondary" onClick={this.handleRetry}>
            Try again
          </button>
        </div>
      );
    }
    return <React.Fragment key={this.state.attempt}>{this.props.children}</React.Fragment>;
  }
}

export default LazyLoadErrorBoundary;
